import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

import MDBox from "@/components/atoms/MDBox";
import { MDButton } from "@/components/atoms/MDButton";
import MDTypography from "@/components/atoms/MDTypography";
import { PlatformsMessages } from "@/messages/platforms/platforms.messages";

const SUPPORT_PORTAL_URL = "https://talk2buy.tomticket.com";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  platformName: string;
  messages: PlatformsMessages;
};

function renderField(label: string, value: string) {
  return (
    <MDBox mb={2}>
      <MDTypography variant="body2" fontWeight="bold" color="dark">
        {label}
      </MDTypography>
      <MDTypography variant="body2" color="text">
        {value}
      </MDTypography>
    </MDBox>
  );
}

export function PlatformConsultModal({ isOpen, onClose, platformName, messages }: Props) {
  const handleOpenPortal = () => {
    window.open(SUPPORT_PORTAL_URL, "_blank", "noopener,noreferrer");
  };

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{messages.consultModalTitle}</DialogTitle>
      <DialogContent>
        <MDTypography variant="body2" color="text" mb={3}>
          {messages.consultModalDescription}
        </MDTypography>

        {renderField(messages.consultModalMessageTypeLabel, messages.consultModalMessageTypeValue)}
        {renderField(messages.consultModalSubjectLabel, `Ativar ${platformName}`)}
        {renderField(messages.consultModalMessageLabel, messages.consultModalMessageValue)}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <MDButton variant="outlined" color="dark" onClick={onClose}>
          {messages.consultModalCloseButton}
        </MDButton>
        <MDButton variant="gradient" color="dark" onClick={handleOpenPortal}>
          {messages.consultModalOpenPortalButton}
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
